module.exports = (() => {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
})();



//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/engine.io-client/lib/globalThis.browser.js
// module id = 31
// module chunks = 0